<div class="box celo-break-word">
  @if (title) {
    <div class="title">{{ title }}</div>
  }
  @if (content) {
    <div class="content alert-content">
      <div class="mx-auto" [innerHtml]="content"></div>
    </div>
  }
  <div class="actions">
    @if (confirmButtonText) {
      <button
        [mat-dialog-close]="true"
        mat-button
        class="celo-primary-button uppercase"
      >
        {{ confirmButtonText }}
      </button>
    }
    @if (!confirmOnly && cancelButtonText) {
      <button
        [mat-dialog-close]="false"
        mat-button
        class="celo-secondary-button uppercase"
      >
        {{ cancelButtonText }}
      </button>
    }
  </div>
</div>
